export function encodeLayers(layers) {
  return btoa(JSON.stringify(layers))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '')
}

export function decodeLayers(str = '') {
  while (str.length % 4 !== 0) str += '='

  const json = str.replace(/-/g, '+').replace(/_/g, '/')
  return JSON.parse(atob(json))
}
